import { Card } from '#record/card';
import { PatchCardProps } from '#submission/patchdetail';
import { useValidationIssueIndex } from '#submission/validator';
import { DateLabel } from '#utils/datelabel';
import { iotcnumberscheme } from '#vid/constants';
import { useVID } from '#vid/model';
import { useT } from 'apprise-frontend-core/intl/language';
import { TagLabel } from 'apprise-frontend-tags/tag/label';
import { useTagStore } from 'apprise-frontend-tags/tag/store';
import { Grid } from 'apprise-ui/grid/grid';
import { Label } from 'apprise-ui/label/label';
import { NamedProperty } from 'apprise-ui/utils/namedproperty';

import { PriorTrxAuthPatch } from '#trxauth.prior/model';
import './styles.scss';


export const PriorTrxAuthzPatchCard = (props: PatchCardProps<PriorTrxAuthPatch>) => {

    const t = useT()

    const { current, record } = props

    const vid = useVID()
    const issues = useValidationIssueIndex()

    const tags = useTagStore()

    return <Card className='priortrxcard' width={400}>

        <Grid rowGap={8} columnGap={10} >

            <Grid.Row>
                <NamedProperty status={issues.uvi} name={<TagLabel bare noIcon tag={tags.allTags().find(t => t.id === iotcnumberscheme)} />}>
                    <Label noIcon title={vid.valueOf(record.uvi)} />
                </NamedProperty>
            </Grid.Row>

            {record.priortrxauthz.authzs.map((authz, i) => {

                return <div key={i} className='priortrxauthz-single'>

                    <Grid.Row>
                        <Grid.Col>
                            <NamedProperty status={issues[`from-${i}`] ?? issues[`from-${i}`]} name={t('trxauthz.from_col')}>
                                <DateLabel noTip noIcon bare date={authz?.from} />
                            </NamedProperty>
                        </Grid.Col>
                        <Grid.Col>
                            <NamedProperty status={issues[`range-${i}`] ?? issues[`to-${i}`]} name={t('priortrxauthz.to_col')}>
                                <DateLabel noTip displayMode={current ? 'expiry' : 'normal'} noIcon date={authz?.to} />
                            </NamedProperty>
                        </Grid.Col>
                    </Grid.Row>


                   {authz?.authorisationNumber && <Grid.Row>
                        <Grid.Col>
                            <NamedProperty status={issues[`number-${i}`]} name={t('priortrxauthz.number_col')}>
                                {authz.authorisationNumber}
                            </NamedProperty>
                        </Grid.Col>
                    </Grid.Row> }

                     {authz.authorisingEntity && <Grid.Row>
                        <Grid.Col style={{overflow:'auto'}}>
                            <NamedProperty  status={issues[`entity-${i}`]} name={t('priortrxauthz.entity_col')}>
                                {authz.authorisingEntity}
                            </NamedProperty>
                        </Grid.Col>
                    </Grid.Row> }

                </div>

            })}
        </Grid >
    </Card >
}
